export const GET_FILE_IMPORTS = "GET_FILE_IMPORTS";
export const GET_FILE_IMPORT_BY_ID = "GET_FILE_IMPORT_BY_ID";
export const UPDATE_FILE_IMPORT = "UPDATE_FILE_IMPORT";
export const DELETE_FILE_IMPORT = "DELETE_FILE_IMPORT";
export const CREATE_FILE_IMPORT = "CREATE_FILE_IMPORT";
